export const featureCards = [
  {
    title: "Find Viral Clips",
    subtitle: "Find moments most likely to perform.",
  },
  {
    title: "Cam Combiner",
    subtitle: "Multi-camera podcast editing and AI direction.",
  },
  {
    title: "Viral Clip Studio",
    subtitle: "Short-form clip creation with captions and B-roll.",
  },
  {
    title: "Smart Promo",
    subtitle: "AI-generated hooks, titles, descriptions, and promotional content.",
  },
  {
    title: "Publish Everywhere",
    subtitle: "Upload once and distribute across multiple platforms.",
  },
];

export const workflowSteps = [
  {
    title: "Upload",
    text: "Drop long-form content and source metadata once.",
  },
  {
    title: "Edit & Enhance",
    text: "Trim, caption, and polish with AI suggestions.",
  },
  {
    title: "Publish",
    text: "Push to platforms from one workspace.",
  },
  {
    title: "Track Results",
    text: "See views, retention, and engagement by channel.",
  },
  {
    title: "Learn & Improve",
    text: "A/B prompts and hooks on top-performing clips.",
  },
];

export const proofChecklist = [
  {
    label: "Clips identified",
    text: "Every upload is scored and split into hook-ready segments.",
  },
  {
    label: "Caption quality",
    text: "Captions are generated per clip format and platform readability checks.",
  },
  {
    label: "Promotion copy",
    text: "Hooks and metadata are optimized for each connected destination.",
  },
];

export const exampleContent = [
  {
    tag: "Long-form to clip",
    text: "From 45 min interview to 12 high-retention clips in minutes.",
  },
  {
    tag: "AI promotion copy",
    text: "Hook + description generated and adapted per platform format.",
  },
  {
    tag: "Platform output",
    text: "Same source clip, optimized with 3 platform-ready variants.",
  },
];

export const pricingCards = [
  {
    name: "Free",
    subtitle: "Start shipping in one day",
    price: "$0",
    note: "Forever",
    cta: "Start Free",
    bullets: [
      "1 long-form project",
      "Core clip extraction",
      "Basic auto captions",
      "One platform publish",
    ],
  },
  {
    name: "Pro",
    subtitle: "For full-time creators",
    price: "$29",
    note: "per month",
    cta: "Start Pro Trial",
    bullets: [
      "Unlimited projects",
      "Smart Promo generation",
      "Multi-platform publish",
      "Advanced analytics",
    ],
    featured: true,
  },
  {
    name: "Team",
    subtitle: "For creator teams",
    price: "$79",
    note: "per month",
    cta: "Talk to Us",
    bullets: ["Shared workspaces", "Review/approve queue", "Team permissions", "Priority support"],
  },
];
